package com.essntl.core.settings.domain.model.configuration

import kotlinx.serialization.json.JsonElement

data class ConfigurationModel(
    val settingKey: String,
    val settingValue: JsonElement,
)
